// Colles with boost >= 2 (Joc del Mocador + chat autocomplete)
export const AVAILABLE_COLLES = [
  "Castellers de Vilafranca",
  "Colla Jove Xiquets de Tarragona",
  "Colla Joves Xiquets de Valls",
  "Colla Vella dels Xiquets de Valls",
  "Minyons de Terrassa",
  "Capgrossos de Mataró",
  "Marrecs de Salt",
  "Moixiganguers d'Igualada",
  "Nens del Vendrell",
  "Xiquets de Reus",
  "Xiquets de Tarragona",
  "Xiquets del Serrallo",
  "Bordegassos de Vilanova",
  "Castellers d'Altafulla",
  "Castellers d'Esparreguera",
  "Castellers d'Esplugues",
  "Castellers de Badalona",
  "Castellers de Barcelona",
  "Castellers de Berga",
  "Castellers de Castelldefels",
  "Castellers de la Sagrada Família",
  "Castellers de la Vila de Gràcia",
  "Castellers de Lleida",
  "Castellers de Sabadell",
  "Castellers de Sant Cugat",
  "Castellers de Sants",
  "Castellers de Sarrià",
  "Castellers de Terrassa",
  "Colla Castellera Jove de Barcelona",
  "Colla Castellera Sant Pere i Sant Pau",
  "Colla Jove de Castellers de Sitges",
  "Nois de la Torre",
  "Sagals d'Osona",
  "Xicots de Vilafranca",
  "Xics de Granollers",
  "Al·lots de Llevant",
  "Arreplegats de la Zona Universitària"
];
